import React, { useEffect, useState } from 'react';
import { ModalBody, ModalHeader } from 'reactstrap';
import Rodal from '../../../components/Rodal/Rodal';
import { LoiSubmissionPackage } from '../../Admin/BuyerMarketplace/OpportunityDetails/LoiSubmissionPackage/LoiSubmissionPackage';
import { LevelOfService, isSfas } from '../../../slices/marketplace/timeline/models/enums/level-of-service.enum';
import { LoiFormsProcessStep, LoiFormsProcess, isLoiResubmissionFlow } from '../../../slices/marketplace/loi-comparison/models/loi-forms-process.model';
import { LoiVersionSelect } from '../../../components/LoiVersionSelect/LoiVersionSelect';

import './LoiFormReviewModal.scss';

const LOI_REVIEW_MODAL_WIDTH = 1200;

export interface LoiFormReviewModalProps {
    isVisible: boolean;
    onClose: () => void;
    engagementId: number;
    loiFormId: string;
    eventId: string;
    documentDetailsId: string | null;
    documentName: string | null;
    buyerName: string;
    onSubmitComplete: () => void;
    levelOfService?: number;
    loiProcessStep: LoiFormsProcessStep;
    buyerId: number;
    isResubmission: boolean;
    loiFormsProcesses: LoiFormsProcess[];
    isAdminEventActive: boolean;
    initialSelectedLoiFormId?: string;
}

export const LoiFormReviewModal = (props: LoiFormReviewModalProps) => {
    const [selectedLoiFormId, setSelectedLoiFormId] = useState<string>(
        props.initialSelectedLoiFormId ?? props.loiFormId
    );

    useEffect(() => {
        setSelectedLoiFormId(props.initialSelectedLoiFormId ?? props.loiFormId);
    }, [props.loiFormId, props.initialSelectedLoiFormId]);

    const isHistoricalVersion = selectedLoiFormId !== props.loiFormId;
    const selectedProcess = props.loiFormsProcesses.find(p => p.loiFormId === selectedLoiFormId);
    const isResubmissionSubmitFlow = isLoiResubmissionFlow(props.loiFormsProcesses);
    const isReadonly = isHistoricalVersion;
    const canSubmit =
        !isHistoricalVersion &&
        props.loiProcessStep === LoiFormsProcessStep.AdminReview &&
        props.isAdminEventActive;

    return (
        <div className="loi-form-review-modal">
            <Rodal
                visible={props.isVisible}
                onClose={props.onClose}
                className="checkout-modal loi-form-review-rodal"
                width={LOI_REVIEW_MODAL_WIDTH}
                customStyles={{ maxWidth: '90vw' }}
                animation="fade"
                showMask={true}
                centered>
                <ModalHeader>
                    <span>LOI Form — {props.buyerName}</span>
                </ModalHeader>
                <ModalBody>
                    <LoiVersionSelect
                        processes={props.loiFormsProcesses}
                        isResubmission={props.isResubmission}
                        currentLoiFormId={props.loiFormId}
                        value={selectedLoiFormId}
                        onChange={setSelectedLoiFormId}
                    />
                    <LoiSubmissionPackage
                        loiFormId={selectedLoiFormId}
                        isHistoricalVersion={isHistoricalVersion}
                        engagementId={props.engagementId}
                        eventId={props.eventId}
                        isReadonly={isReadonly}
                        selectedProcess={selectedProcess}
                        documentDetailsId={selectedProcess?.documentDetailsId ?? undefined}
                        uploadedDocumentName={selectedProcess?.documentName ?? undefined}
                        onDataChange={props.onSubmitComplete}
                        isFsb={props.levelOfService === LevelOfService.FullServiceBrokerage}
                        isSfas={isSfas(props.levelOfService)}
                        isAdmin={true}
                        canSubmit={canSubmit}
                        buyerId={props.buyerId}
                        isResubmission={isResubmissionSubmitFlow}
                    />
                </ModalBody>
            </Rodal>
        </div>
    );
};
